import { render, staticRenderFns } from "./VipOrder.vue?vue&type=template&id=638a762a&scoped=true"
import script from "./VipOrder.vue?vue&type=script&lang=js"
export * from "./VipOrder.vue?vue&type=script&lang=js"
import style0 from "./VipOrder.vue?vue&type=style&index=0&id=638a762a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a762a",
  null
  
)

export default component.exports